import { startError } from "../../error";

export const handleError = (errors: any, metaData: any): void => startError(errors, metaData);
